import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
};

const subscriptionModalSlice = createSlice({
  name: 'subscriptionModal',
  initialState,
  reducers: {
    openSubscriptionModal: (state) => {
      state.open = true;
    },
    closeSubscriptionModal: (state) => {
      state.open = false;
    },
  },
});

export const { openSubscriptionModal, closeSubscriptionModal } = subscriptionModalSlice.actions;
export default subscriptionModalSlice.reducer;